module.exports = __webpack_public_path__ + "media/src/images/balloons/balloons-084241208777aa57d31a684a071860a8.png";